<template>
    <div
        class="flow-scroll-quotes-container"
        :class="[isWebPcMode ? '' : 'flow-scroll-quotes-container-h5']"
        v-if="showQuotesContent"
    >
        <div class="swiper" ref="swiper" :style="swiperWrapStyle">
            <div class="swiper-wrapper" ref="swiperWrapperRef">
                <div class="swiper-slide" v-for="(item, index) in stockList" :key="'swiper-slide' + index">
                    <p class="slide-stock-name" :style="stockNameStyle">{{ item.showName }}</p>
                    <div class="slide-stock-info" :class="[riseFallColor]">
                        <span
                            class="stock-price"
                            :class="[item.updown >= 0 ? 'rise' : 'fall']"
                            :style="stockPriceStyle"
                        >
                            {{ item.priceNominal }}
                        </span>
                        <span
                            class="stock-updown"
                            :class="[item.updown >= 0 ? 'rise' : 'fall']"
                            :style="stockTrendStyle"
                        >
                            {{ item.updown }}%
                        </span>
                        <span class="stock-icon" :class="[item.updown > 0 ? 'rise' : 'fall']" v-show="item.updown">
                            <svg
                                t="1670399685740"
                                class="icon"
                                viewBox="0 0 1024 1024"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                p-id="6535"
                                width="1em"
                                height="1em"
                                fill="currentColor"
                            >
                                <path
                                    d="M416 64h192c26.6 0 48 21.4 48 48v400h207.6c42.8 0 64.2 51.6 34 82L546 946c-18.8 18.8-49.2 18.8-68 0L126.6 594c-30.2-30.2-8.8-82 34-82H368V112c0-26.6 21.4-48 48-48z"
                                    p-id="6536"
                                ></path>
                            </svg>
                        </span>
                    </div>
                    <div class="split-line" :style="splitLineStyle"></div>
                </div>
                <div class="swiper-slide" v-for="(item, index) in stockList" :key="'swiper-slide' + index">
                    <p class="slide-stock-name" :style="stockNameStyle">{{ item.showName }}</p>
                    <div class="slide-stock-info" :class="[riseFallColor]">
                        <span
                            class="stock-price"
                            :class="[item.updown >= 0 ? 'rise' : 'fall']"
                            :style="stockPriceStyle"
                        >
                            {{ item.priceNominal }}
                        </span>
                        <span
                            class="stock-updown"
                            :class="[item.updown >= 0 ? 'rise' : 'fall']"
                            :style="stockTrendStyle"
                        >
                            {{ item.updown }}%
                        </span>
                        <span class="stock-icon" :class="[item.updown > 0 ? 'rise' : 'fall']" v-show="item.updown">
                            <svg
                                t="1670399685740"
                                class="icon"
                                viewBox="0 0 1024 1024"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                p-id="6535"
                                width="1em"
                                height="1em"
                                fill="currentColor"
                            >
                                <path
                                    d="M416 64h192c26.6 0 48 21.4 48 48v400h207.6c42.8 0 64.2 51.6 34 82L546 946c-18.8 18.8-49.2 18.8-68 0L126.6 594c-30.2-30.2-8.8-82 34-82H368V112c0-26.6 21.4-48 48-48z"
                                    p-id="6536"
                                ></path>
                            </svg>
                        </span>
                    </div>
                    <div class="split-line" :style="splitLineStyle"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper, { Autoplay, FreeMode } from 'swiper';
import 'swiper/css/swiper.css';

import CONST from '../common/constants.js';
import { rem, isPcMode } from '../fego/utils.js';
import { get } from '../fego/render.js';

import Toast from '@futuweb/future-ui/es/toast';
import '@futuweb/future-ui/es/toast/style/index.css';

Toast.config({
    duration: 2,
    clickHide: false,
    withMask: false
});


const {
    common: { request: { bindCommonApi }, },
} = require('@futuweb/fego-render');

const commonApiRequest = bindCommonApi('flow-scroll-quotes');
export default {
    components: {},
    props: {
        // 主题
        theme: {
            type: String
        },
        // 显示语言
        language: {
            type: String
        },
        // 股票市场
        market: {
            type: String
        },
        // 速度
        speed: {
            type: Number
        },
        // 涨跌色
        upDownColor: {
            type: String
        },
        // 背景颜色
        bgColor: {
            type: String
        },
        // 分割线颜色设置
        lineColor: {
            type: String
        },
        // 股票名字号
        stockFontSize: {
            type: Number
        },
        // 股票名颜色
        stockFontColor: {
            type: String
        },
        // 股票名字体
        stockFontFamily: {
            type: String
        },
        // 股票价格字号
        stockPriceFontSize: {
            type: Number
        },
        // 股票价格字体
        stockPriceFontFamily: {
            type: String
        },
        // 股票涨跌字号
        trendFontSize: {
            type: Number
        },
        // 股票涨跌字体
        trendFontFamily: {
            type: String
        },
        // 自定义填写的股票列表
        customStocklist: {
            type: Array
        }
    },
    data() {
        return {
            showQuotesContent: false, // 是否展示行情滚动banner, 若数据查询有误则隐藏
            stockList: [],
            moveX: 0
        };
    },
    watch: {},
    computed: {
        isWebPcMode() {
            return isPcMode();
        },
        // 涨跌色判断
        riseFallColor() {
            if (this.upDownColor === CONST.UP_DOWN_COLOR.greenUp) {
                return 'slide-stock-info-green-rise-red-fall';
            } else {
                return 'slide-stock-info-red-rise-gree-fall';
            }
        },
        // 背景色
        swiperWrapStyle() {
            // 自定义主题情况下, 可自由设置背景色
            let color = '';
            switch (this.theme) {
                case CONST.THEME.BLACK:
                    color = '#202020';
                    break;
                case CONST.THEME.WHITE:
                    color = '#FAFAFA';
                    break;
                case CONST.THEME.CUSTOMER:
                    color = this.bgColor;
                    break;
            }
            return {
                backgroundColor: color
            };
        },
        // 右侧线颜色
        splitLineStyle() {
            // 自定义主题情况下, 可自由设置背景色
            let color = '';
            switch (this.theme) {
                case CONST.THEME.BLACK:
                    color = '#323232';
                    break;
                case CONST.THEME.WHITE:
                    color = '#E5E5E5';
                    break;
                case CONST.THEME.CUSTOMER:
                    color = this.lineColor;
                    break;
            }
            return {
                backgroundColor: color
            };
        },
        // 股票名样式
        stockNameStyle() {
            // 自定义主题情况下, 可自由设置背景色
            let color = '';
            let fontSize = '';
            let fontFamily = '';
            switch (this.theme) {
                case CONST.THEME.BLACK:
                    color = '#E5E5E5';
                    fontSize = rem.str(isPcMode() ? CONST.STOCK_NAME_FONT_SIZE.WEB : CONST.STOCK_NAME_FONT_SIZE.H5);
                    fontFamily = CONST.STOCK_NAME_FONT_FAMILY;
                    break;
                case CONST.THEME.WHITE:
                    color = '#262626';
                    fontSize = rem.str(isPcMode() ? CONST.STOCK_NAME_FONT_SIZE.WEB : CONST.STOCK_NAME_FONT_SIZE.H5);
                    fontFamily = CONST.STOCK_NAME_FONT_FAMILY;
                    break;
                case CONST.THEME.CUSTOMER:
                    color = this.stockFontColor;
                    fontSize = rem.str(this.stockFontSize);
                    fontFamily = this.stockFontFamily;
                    break;
            }
            return {
                color,
                fontSize,
                fontFamily
            };
        },
        // 股票价格样式
        stockPriceStyle() {
            // 自定义主题情况下, 可自由设置背景色
            let fontSize = '';
            let fontFamily = '';
            switch (this.theme) {
                case CONST.THEME.BLACK:
                    fontSize = rem.str(isPcMode() ? CONST.STOCK_PRICE_FONT_SIZE.WEB : CONST.STOCK_PRICE_FONT_SIZE.H5);
                    fontFamily = CONST.STOCK_PRICE_FONT_FAMILY;
                    break;
                case CONST.THEME.WHITE:
                    fontSize = rem.str(isPcMode() ? CONST.STOCK_PRICE_FONT_SIZE.WEB : CONST.STOCK_PRICE_FONT_SIZE.H5);
                    fontFamily = CONST.STOCK_PRICE_FONT_FAMILY;
                    break;
                case CONST.THEME.CUSTOMER:
                    fontSize = rem.str(this.stockPriceFontSize);
                    fontFamily = this.stockPriceFontFamily;
                    break;
            }
            return {
                fontSize,
                fontFamily
            };
        },
        // 股票走势样式
        stockTrendStyle() {
            // 自定义主题情况下, 可自由设置背景色
            let fontSize = '';
            let fontFamily = '';
            switch (this.theme) {
                case CONST.THEME.BLACK:
                    fontSize = rem.str(isPcMode() ? CONST.STOCK_TREND_FONT_SIZE.WEB : CONST.STOCK_TREND_FONT_SIZE.H5);
                    fontFamily = CONST.STOCK_TREND_FONT_FAMILY;
                    break;
                case CONST.THEME.WHITE:
                    fontSize = rem.str(isPcMode() ? CONST.STOCK_TREND_FONT_SIZE.WEB : CONST.STOCK_TREND_FONT_SIZE.H5);
                    fontFamily = CONST.STOCK_TREND_FONT_FAMILY;
                    break;
                case CONST.THEME.CUSTOMER:
                    fontSize = rem.str(this.trendFontSize);
                    fontFamily = this.trendFontFamily;
                    break;
            }
            return {
                fontSize,
                fontFamily
            };
        }
    },
    methods: {
        init() {
            const run = () => {
                if (this.scrollTimer) {
                    clearTimeout(this.scrollTimer);
                    this.scrollTimer = null;
                }
                this.scrollTimer = setTimeout(() => {
                    let wrapperWidth = 0;
                    if (this.$refs.swiperWrapperRef && this.$refs.swiperWrapperRef.hasChildNodes()) {
                        const childList = this.$refs.swiperWrapperRef.children;
                        for (const item of childList) {
                            wrapperWidth += item.offsetWidth;
                        }
                        let half = wrapperWidth >> 1;
                        if (this.moveX < 1 - half) {
                            this.moveX = 0;
                        }
                        this.moveX -= this.speed / 10;
                        this.$refs.swiperWrapperRef.style.transform = `translate(${this.moveX}px)`;
                    }
                    run();
                }, 16);
            };
            run();
            this.initEvent();
        },
        initEvent() {
            this.$refs.swiperWrapperRef && (this.$refs.swiperWrapperRef.onmouseenter = () => {
                this.reInitSwiper();
            });
            this.$refs.swiperWrapperRef && (this.$refs.swiperWrapperRef.onmouseleave = () => {
                this.init();
            });
        },
        // 销毁swiper并重新初始化
        reInitSwiper() {
            clearTimeout(this.scrollTimer);
            this.scrollTimer = null;
        },
        // 获取市场热门股
        async getMarketStock() {
            const res = await commonApiRequest.get(
                'quotes',
                {
                    marketId: this.market
                }
            ).catch((error) => {
                this.showQuotesContent = false;
            });
            if (!res || (res && res.length <= 0)) {
                return;
            }
            this.showQuotesContent = true;
            for (const item of res) {
                item.showName = item[this.language];
            }
            this.stockList = res;
            this.$nextTick(() => {
                this.init();
            });
        },
        // 获取自定义股票数据
        async getCustomStock(stockList) {
            const res = await commonApiRequest.post('quotes-custom', {
                stockList: stockList
            }).catch((error) => {
                this.showQuotesContent = false;
            });
            if (!res || (res && res.length <= 0)) {
                return;
            }
            this.showQuotesContent = true;
            for (const item of res) {
                item.showName = item[this.language];
            }
            for (let item of this.customStocklist) {
                let findOne = res.find((val) => {
                    return val.srcCode === item.stock;
                });
                if (findOne) {
                    item = Object.assign(item, findOne);
                }
            }

            let showList = this.customStocklist.filter((item) => {
                return item.srcCode;
            });

            this.stockList = showList;
            this.$nextTick(() => {
                this.init();
            });
        },

        // 判断股票列表的格式是否正确
        checkCustomStockList(list) {
            return list.every((val) => {
                if (!val) {
                    return false;
                }
                const match = val.match(/^([A-Z0-9\.]+)\.([A-Z]+)$/);
                if (match) {
                    // 匹配是否满足已支持市场
                    return CONST.MARKET_ARR.includes(match[2]);
                }
                return false;
            });
        }
    },
    created() {},
    mounted() {
        if (this.market === 'custom-stock') {
            // 自定义股票类型
            if (this.customStocklist.length <= 0) {
                Toast.tips('未填写自定义股票列表');
                return;
            }
            // 校验
            let stockList = Array.from(this.customStocklist, ({ stock }) => stock);

            if (this.checkCustomStockList(stockList)) {
                // 符合要求，请求接口
                this.getCustomStock(stockList);
                setInterval(() => {
                    this.getCustomStock(stockList);
                }, 3e5); // 设置定时器, 5分钟
                document.addEventListener('visibilitychange', () => {
                    if (document.visibilityState === 'visible') {
                        this.init();
                    } else {
                        this.reInitSwiper();
                    }
                });
            } else {
                Toast.tips('无法获取数据，请检查输入');
            }
        } else {
            this.getMarketStock();
            setInterval(() => {
                this.getMarketStock();
            }, 3e5); // 设置定时器, 5分钟
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'visible') {
                    this.init();
                } else {
                    this.reInitSwiper();
                }
            });
        }
    }
};
</script>
<style lang="less" scoped>
.flow-scroll-quotes-container {
    width: 100% !important;
    height: auto !important;
    position: relative;
    .swiper {
    }
    .swiper-wrapper {
        height: 0.78rem;
        display: flex;
        -webkit-transition-timing-function: linear;
        -moz-transition-timing-function: linear;
        -ms-transition-timing-function: linear;
        -o-transition-timing-function: linear;
        transition-timing-function: linear;
        .swiper-slide {
            padding: 0.2rem 0.5rem 0.2rem 0.5rem;
            position: relative;
            width: auto;
            .slide-stock-name {
                font-size: 0.16rem;
                line-height: 1;
            }
            .slide-stock-info {
                display: flex;
                line-height: 1;
                margin-top: 0.06rem;
                align-items: center;
                .stock-price {
                    font-size: 0.16rem;
                    margin-right: 0.05rem;
                }
                .stock-updown {
                    font-size: 0.12rem;
                }
                .stock-icon {
                    margin-left: 0.05rem;
                    .icon {
                        min-width: 12px;
                        min-height: 12px;
                        width: 0.12rem;
                        height: 0.12rem;
                    }
                }
            }
            .split-line {
                width: 0.01rem;
                height: 0.4rem;
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
            }
            .slide-stock-info-green-rise-red-fall {
                .rise {
                    color: #00a843;
                    .icon {
                        transform: rotate(180deg);
                    }
                }
                .fall {
                    color: #f13e3a;
                }
            }
            .slide-stock-info-red-rise-gree-fall {
                .rise {
                    color: #f13e3a;
                    .icon {
                        transform: rotate(180deg);
                    }
                }
                .fall {
                    color: #00a843;
                }
            }
        }
    }
}
.flow-scroll-quotes-container-h5 {
    .swiper-wrapper {
        height: 1.24rem;
        .swiper-slide {
            padding: 0.3rem 0.4rem 0.3rem 0.4rem;
            .slide-stock-info {
                margin-top: 0.1rem;
            }
            .slide-stock-info {
                .stock-icon {
                    .icon {
                        width: 0.16rem;
                        height: 0.18rem;
                    }
                }
            }
        }
    }
}
</style>
